<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import DashboardNavIcon from '@/components/dashboard/shell/DashboardNavIcon.vue'
import { claimTaxYearConfig } from '@/composables/useClaimTaxBack'

/**
 * Status mark for a Gift Aided donation in a claimed year. List rows show
 * "Claimed tax back"; the detail modal can show the amber icon only, next
 * to the date. The tax year stays in the accessible name.
 */
withDefaults(
  defineProps<{
    iconOnly?: boolean
  }>(),
  { iconOnly: false }
)

const { t } = useI18n()
const yearLabel = claimTaxYearConfig.yearLabel
</script>

<template>
  <span
    class="sa-donation-claim-mark"
    :class="{ 'sa-donation-claim-mark--icon-only': iconOnly }"
  >
    <DashboardNavIcon name="claim" />
    <span class="sa-sr-only">
      {{ t('Dashboard.Giving.Table.IncludedInClaimAria', { year: yearLabel }) }}
    </span>
    <span v-if="!iconOnly" aria-hidden="true">
      {{ t('Dashboard.Giving.Table.Claimed') }}
    </span>
  </span>
</template>
